import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["variant", "className", "children"];
import * as React from 'react';
import clsx from 'clsx';
import { getElementChildren } from '../../../utils';
import { Base } from '../../Base';
import { ListItem } from '../ListItem';
var styles = {
  "root": "OrderedList-root_2ZZnN",
  "item": "OrderedList-item_3_J1c",
  "hasHelp": "OrderedList-hasHelp_O6u6F",
  "plain": "OrderedList-plain_2Os6r",
  "bordered": "OrderedList-bordered_1crX_"
};
function OrderedList(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'plain' : _ref$variant,
    className = _ref.className,
    children = _ref.children,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var hasHelp = false;
  var elements = getElementChildren(children);

  // @TODO: Filter for React Elements.
  var items = React.Children.map(elements, function (child) {
    hasHelp = hasHelp || React.Children.count(child.props.children) > 1;
    return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({
      flex: true,
      flexAlignItemsCenter: true,
      flexWrap: hasHelp
    }, child.props), {}, {
      // Positioned last so it don't get overriden by the above spread.
      className: clsx(child.props.className, styles.item, styles[variant])
    }));
  });
  return /*#__PURE__*/React.createElement(Base, _extends({
    tagName: "ol",
    margin: "none",
    padding: "none",
    listStyleType: "none",
    className: clsx(styles.root, _defineProperty({}, styles.hasHelp, hasHelp), className)
  }, extraProps), items);
}
export { OrderedList };